// Single source of truth for finding-severity color coding, shared by the
// pentest submission form and every read-only finding view (admin + participant).
export const SEVERITY_STYLES = {
  Critical:      { bg: '#842029', text: '#fff' },
  High:          { bg: '#664d03', text: '#fff' },
  Medium:        { bg: '#084298', text: '#fff' },
  Low:           { bg: '#0f5132', text: '#fff' },
  Informational: { bg: '#495057', text: '#fff' },
};
